import { ActionType, createReducer } from 'typesafe-actions'
import * as actions from './actions'

export type RootAction = ActionType<typeof actions>

export const reducer = createReducer<{ [key: string]: number }, RootAction>(
  {}
).handleAction(actions.answerQuestion, (state, action) => {
  return {
    ...state,
    [action.meta]: action.payload as number
  }
})
